module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};



//////////////////
// WEBPACK FOOTER
// ./~/mapbox.js/~/isarray/index.js
// module id = 350
// module chunks = 1